export default abstract class Component extends HTMLElement {

    public render(parent: HTMLElement): void {
        parent.appendChild(this);
    }
}
